import { render, staticRenderFns } from "./drawerContent.vue?vue&type=template&id=5c209a5c&scoped=true"
import script from "./drawerContent.vue?vue&type=script&lang=js"
export * from "./drawerContent.vue?vue&type=script&lang=js"
import style0 from "./drawerContent.vue?vue&type=style&index=0&id=5c209a5c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c209a5c",
  null
  
)

export default component.exports